import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import Icon from "./Icon";

var InfoBox = function InfoBox(_ref) {
  var _classnames, _classnames2;

  var children = _ref.children,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'info' : _ref$color,
      icon = _ref.icon,
      title = _ref.title,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? false : _ref$vertical,
      props = _objectWithoutProperties(_ref, ["children", "className", "color", "icon", "title", "vertical"]);

  var classNames = classnames('rg-InfoBox', 'bg-white', 'shadow', 'p-3', className, (_classnames = {}, _defineProperty(_classnames, "border-".concat(color), color), _defineProperty(_classnames, 'border-top', vertical), _defineProperty(_classnames, 'border-left', !vertical), _classnames));
  var headerClasses = classnames('font-weight-normal d-flex justify-content-between m-0', (_classnames2 = {}, _defineProperty(_classnames2, "text-".concat(color), color), _defineProperty(_classnames2, 'mb-3', !!children), _classnames2));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: "jsx-1674485803" + " " + (props && props.className != null && props.className || classNames || "")
  }), title && /*#__PURE__*/React.createElement("h1", {
    className: "jsx-1674485803" + " " + (headerClasses || "")
  }, title, icon ? /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }) : null), children && /*#__PURE__*/React.createElement("div", {
    className: "jsx-1674485803" + " " + "infobox-body"
  }, children)), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1674485803"
  }, ".rg-InfoBox.jsx-1674485803{border-width:0.55rem !important;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;}"));
};

InfoBox.displayName = 'InfoBox';
export default InfoBox;